import { Component, ElementRef, Input, OnInit, viewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { EditorTextComponent } from '../../../home/editor-text/editor-text.component';
import { ContactFormComponent } from '../contact-form/contact-form.component';

@Component({
  selector: 'calsoft-doubleimageform',
  imports: [CustomFlexLayoutModule, EditorTextComponent, ContactFormComponent],
  templateUrl: './doubleimageform.component.html',
  styleUrl: './doubleimageform.component.scss'
})
export class DoubleimageformComponent implements OnInit {


  readonly containerDiv = viewChild<ElementRef>('containerDiv');
  readonly secondElement = viewChild<ElementRef>('secondElement');
  readonly positionedElement = viewChild<ElementRef>('positionedElement');

  constructor() {}

  ngAfterViewInit() {
   
    if (window.innerWidth >= 1280) {
      this.setPosition();
    }
  }

  setPosition() {
    if (this.containerDiv() && this.secondElement() && this.positionedElement()) {
      // Get the height of the container and the second element

      // Get the top position of the second element relative to the viewport

      // // Calculate the center position: the middle point between the container and the second element
      // const centerPosition = containerHeight + (secondElementTop - containerHeight - secondElementHeight) / 2;

      // // Set the top property of the positioned element dynamically
      // this.positionedElement.nativeElement.style.top = `${centerPosition}px`;
    }
  }



  @Input() item: any;
  @Input() img: any;
  @Input() data : any;


  public serverPath = environment.commonImageApi + '/home/';

  ngOnInit() {

    
  }
  
}
